import type { TrophySet } from '@plathunt/types';

type Counts = TrophySet['trophyCount'];

/**
 * Zusammensetzung des Sets nach Trophäentyp.
 *
 * Bewusst KEIN Fortschrittsbalken: der Earned State kommt erst mit dem
 * PSN-Sync. Hier steht nur, woraus das Set besteht – echte Daten, kein
 * vorgetäuschter Fortschritt.
 */
export function TrophyCountBar({ counts, hasPlatinum }: { counts: Counts; hasPlatinum: boolean }) {
  const segments = [
    { key: 'bronze', label: 'Bronze', value: counts.bronze },
    { key: 'silver', label: 'Silber', value: counts.silver },
    { key: 'gold', label: 'Gold', value: counts.gold },
    { key: 'platinum', label: 'Platin', value: counts.platinum },
  ].filter((segment) => segment.value > 0);

  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  if (total === 0) return null;

  return (
    <div className="ph-counts">
      <div className="ph-counts__bar" role="img" aria-label={`${total} Trophäen in diesem Set`}>
        {segments.map((segment) => (
          <span
            key={segment.key}
            className={`ph-counts__seg ph-counts__seg--${segment.key}`}
            style={{ flexGrow: segment.value }}
          />
        ))}
      </div>
      <ul className="ph-counts__legend">
        {segments.map((segment) => (
          <li key={segment.key} className="ph-counts__item">
            <span className={`ph-dot ph-dot--${segment.key}`} aria-hidden="true" />
            {segment.value} {segment.label}
          </li>
        ))}
      </ul>
      {hasPlatinum && (
        <p className="ph-counts__note">Platin gehört zum Base Game, nicht zu den DLC-Gruppen.</p>
      )}
    </div>
  );
}
